import { AxiosResponse } from "axios";
import { deleteData, getData, postData } from "./apiInstance";
import {
  AddEditTimeSheetDataPayloadType,
  GetTimeSheetDataPayloadType,
  DeleteTimeSheetDataPayloadType,
  GetTimeSheetReportDataPayloadType,
  GetTimeSheetUserWorkOnSpecificJobPayloadType,
  EmailAllUserTimesheetReportPayloadType,
  GetTimeSheetSummaryReportDataPayloadType,
  GetTimesheetSummaryReportDownloadPayloadType,
  GetAllUserAttendanceReportDataPayloadType,
  GetSingleUserAttendanceReportDataPayloadType,
  GetMissingTimesheetSummaryReport,
  GetTimesheetVsSchedulngMonthlyReport,
  EmailTimesheetVsSchedulingMonthlyReportType,
  GetTimeSheetSummaryClientWiseUserPayloadType,
  AddRegularizePayloadType,
  GetClientWiseMonthlyReportPayloadType,
} from "../commonTypes/timeSheetTypes";
import { UpdateBranchDataPayloadType } from "../commonTypes/masterDataTypes";
import { getCSRFToken } from "../utils/commonFunctions";
import { GetScheduledJobsHourPayloadType } from "../commonTypes/schedulingTypes";

export async function addTimeSheetDataApi(
  data: AddEditTimeSheetDataPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    type,
    client_code,
    date,
    job,
    start_time,
    end_time,
    activity_code,
    comments,
  } = data;

  return await postData(
    `master-module/timesheet/add`,
    {
      type,
      client_code,
      date,
      job,
      start_time,
      end_time,
      activity_code,
      comments,
    },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function getTimeSheetApi(
  data: GetTimeSheetDataPayloadType
): Promise<AxiosResponse> {
  const { token, date } = data;
  return await getData(`master-module/timesheet/list`, {
    params: {
      date,
    },
    headers: {
      "user-token": token,
      "Content-Type": "application/json",
    },
  });
}

export async function deleteTimeSheetApi(
  data: DeleteTimeSheetDataPayloadType
): Promise<AxiosResponse> {
  const { token, id } = data;
  return await deleteData(`master-module/timesheet/delete`, {
    headers: {
      "user-token": token,
      "Content-Type": "application/json",
      "x-csrf-token": getCSRFToken(),
    },
    params: {
      id,
    },
  });
}
// updateTimeSheetApi

export async function updateTimeSheetApi(
  data: AddEditTimeSheetDataPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    id,
    type,
    client_code,
    date,
    job,
    start_time,
    end_time,
    activity_code,
    comments,
  } = data;

  return await postData(
    `master-module/timesheet/update`,
    {
      id,
      type,
      client_code,
      date,
      job,
      start_time,
      end_time,
      activity_code,
      comments,
    },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

//  timesheet report
export async function getTimeSheetReportApi(
  data: GetTimeSheetReportDataPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    startDate,
    endDate,
    userBasicDetails,
    limit,
    offset,
    userId,
    activityCode,
    type,
  } = data;
  let finalParams = {
    limit,
    offset,
    start_date: startDate,
    end_date: endDate,
    user_id: userId ? userId : null,
    type: type === "Billable" ? 1 : type === "Non Billable" ? 2 : "",
    activity_code: activityCode === "Select.." ? "" : activityCode,
  };
  return await getData(`master-module/timesheet/user/report`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getTimeSheetCalendarReportApi(
  data: GetTimeSheetReportDataPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    startDate,
    endDate,
    userBasicDetails,
    limit,
    offset,
    userId,
    activityCode,
    type,
  } = data;
  let finalParams = {
    // limit,
    // offset,
    start_date: startDate,
    end_date: endDate,
    user_id: userId ? userId : null,
    type: type === "Billable" ? 1 : type === "Non Billable" ? 2 : "",
    activity_code: activityCode === "Select.." ? "" : activityCode,
  };
  return await getData(`master-module/timesheet/user/report/calendar-list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
// timesheet report download
export async function downloadTimesheetReportApi(
  data: any
): Promise<AxiosResponse> {
  const {
    token,
    // client_code,
    user_id,
    start_date,
    end_date,
    type,
    activity_code,
  } = data;
  let finalParams = {
    start_date: start_date,
    end_date: end_date,
    user_id: user_id ? user_id : null,
    type: type === "Billable" ? 1 : type === "Non Billable" ? 2 : "",
    activity_code: activity_code === "Select.." ? "" : activity_code,
  };

  return await getData(`master-module/timesheet/user/report/download`, {
    params: {
      ...finalParams,
    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
//  timesheetUnfilled report

export async function getTimeSheetUnfilledReportApi(
  data: GetMissingTimesheetSummaryReport
): Promise<AxiosResponse> {
  const { token, start_date, end_date } = data;
  return await getData(`master-module/incomplete/timesheet/user/report`, {
    params: {
      start_date: start_date ? start_date : "",
      end_date: end_date ? end_date : "",
    },
    headers: {
      "user-token": token,
      "Content-Type": "application/json",
    },
  });
}

// user work on specific job
export async function getTimesheetReportHoursForSpecificJobApi(
  data: GetTimeSheetUserWorkOnSpecificJobPayloadType
): Promise<AxiosResponse> {
  const { token, job_id, limit, offset } = data;

  return await getData(`master-module/timesheet/job/work/time/report`, {
    params: {
      job_id,
      limit,
      offset,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// Email Timesheet Report
export async function emailAllUserTimesheetReportApi(
  data: EmailAllUserTimesheetReportPayloadType
): Promise<AxiosResponse> {
  const { token, start_date, end_date } = data;

  return await postData(
    `/master-module/timesheet-report/send-email`,
    { start_date, end_date },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

// Email Attendance Report
export async function emailAllUserAttendanceReportApi(
  data: EmailAllUserTimesheetReportPayloadType
): Promise<AxiosResponse> {
  const { token, start_date, end_date, department } = data;

  return await postData(
    `/master-module/attendence-report/send-email`,
    { start_date, end_date, department },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

//  timesheet summary report api
export async function getTimeSheetSummaryReportApi(
  data: GetTimeSheetSummaryReportDataPayloadType
): Promise<AxiosResponse> {
  const { token, start_date, end_date, limit, offset, branch_filter } = data;
  let finalParams = {
    limit,
    offset,
    start_date,
    end_date,
    branch_filter,
  };
  return await getData(`master-module/timesheet/user/work-report`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getAllUserTimeSheetReportApi(
  data: GetAllUserAttendanceReportDataPayloadType
): Promise<AxiosResponse> {
  const { token, start_date, end_date, limit, offset, department } = data;
  let finalParams = {
    limit,
    offset,
    start_date,
    end_date,
    department,
  };
  return await getData(`/master-module/attendence/alluser/report`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getSingleUserTimeSheetReportApi(
  data: GetSingleUserAttendanceReportDataPayloadType
): Promise<AxiosResponse> {
  const { token, start_date, end_date, limit, offset, user_id,notificationId } = data;
  let finalParams = {
    limit,
    offset,
    start_date,
    end_date,
    user_id,
    ...(notificationId&&{notification_id:notificationId}),
    ...(notificationId&&{is_page_seen:true})
  };
  return await getData(`/master-module/attendence/report`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

//  timesheet summary download
export async function downloadTimesheetSummaryReportApi(
  data: GetTimesheetSummaryReportDownloadPayloadType
): Promise<AxiosResponse> {
  const { token, start_date, end_date, branch_filter } = data;
  let finalParams = {
    start_date: start_date,
    end_date: end_date,
    branch_filter,
  };

  return await getData(`master-module/timesheet/user/work-report/download`, {
    params: {
      ...finalParams,
    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// client wise user timesheet summary download
export async function downloadClientWiseUserTimeSheetReportApi(
  data: GetTimeSheetSummaryClientWiseUserPayloadType
): Promise<AxiosResponse> {
  const { token, start_date, end_date, client_code } = data;
  let finalParams = {
    start_date: start_date,
    end_date: end_date,
    client_code,
  };

  return await getData(
    `master-module/timesheet/client-wise/user/report/download`,
    {
      params: {
        ...finalParams,
      },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
      },
    }
  );
}

export async function getTimesheetVsSchedulingMonthlyReportApi(
  data: GetTimesheetVsSchedulngMonthlyReport
): Promise<AxiosResponse> {
  const { token, start_date, limit, offset, end_date, user_id, department } =
    data;
  let finalParams = {
    start_date,
    end_date,
    limit,
    offset,
    user_id,
    department,
  };
  return await getData(`/master-module/charged-vs-scheduled-hours/report`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function emailTimesheetVsSchedulingMonthlyReportApi(
  data: EmailTimesheetVsSchedulingMonthlyReportType
): Promise<AxiosResponse> {
  const { token, start_date, end_date, department } = data;
  let finalParams = {
    start_date,
    end_date,
    department,
  };

  return await getData(
    `/master-module/charged-vs-scheduled-hours/report/send-email`,
    {
      params: {
        ...finalParams,
      },
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
      },
    }
  );
}

export async function emailClientWiseTimeSheetReportApi(
  data: EmailTimesheetVsSchedulingMonthlyReportType
): Promise<AxiosResponse> {
  const { token, start_date, end_date } = data;

  return await postData(
    `/master-module/timesheet-report/client-wise-user/send-email`,
    { start_date, end_date },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function clientWiseUserTimeSheetReportApi(
  data: GetTimeSheetSummaryClientWiseUserPayloadType
): Promise<AxiosResponse> {
  const { token, start_date, end_date, client_code, limit, offset } = data;
  let finalParams = {
    start_date,
    end_date,
    client_code,
    limit,
    offset,
  };

  return await getData(`/master-module/timesheet/client-wise/user/report`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function addRegularizeApi(data: AddRegularizePayloadType): Promise<AxiosResponse> {
  const { token, date, manager, startTime, endTime, comment } = data;
  return await postData(
    `master-module/attendance/regularize/add`,
    {
      date: date,
      manager: manager,
      start_time: startTime,
      end_time: endTime,
      employee_comment: comment,
      status: 1,
    },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}


export async function clientWiseMonthlyTimeSheetReportApi(
  data: GetClientWiseMonthlyReportPayloadType
): Promise<AxiosResponse> {
  const { token, start_date, end_date, client_code } = data;
  let finalParams = {
    start_date,
    end_date,
    client_code,
  };

  return await getData(`/master-module/timesheet/client-wise/monthly/report`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function downloadClientWiseMonthlyTimeSheetReportApi(
  data: GetTimeSheetSummaryClientWiseUserPayloadType
): Promise<AxiosResponse> {
  const { token, start_date, end_date, client_code } = data;
  let finalParams = {
    start_date: start_date,
    end_date: end_date,
    client_code,
  };

  return await getData(
    `master-module/timesheet/client-wise/monthly/report/download`,
    {
      params: {
        ...finalParams,
      },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
      },
    }
  );
}


export async function monthWiseTimeSheetReportApi(
  data: GetClientWiseMonthlyReportPayloadType
): Promise<AxiosResponse> {
  const { token, start_date, end_date } = data;
  let finalParams = {
    start_date,
    end_date
  };

  return await getData(`master-module/timesheet/month-wise/client/report`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
export async function downloadMonthWiseClientTimeSheetReportApi(
  data: GetTimeSheetSummaryClientWiseUserPayloadType
): Promise<AxiosResponse> {
  const { token, start_date, end_date } = data;
  let finalParams = {
    start_date: start_date,
    end_date: end_date,
  };

  return await getData(
    `master-module/timesheet/month-wise/client/report/download`,
    {
      params: {
        ...finalParams,
      },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
      },
    }
  );
}


export async function getOpenJobChargedHoursTimesheetApi(
  data: GetScheduledJobsHourPayloadType
): Promise<AxiosResponse> {
  const { token, job_id } = data;
  let finalParams = {
    job_id,
  };

  return await getData(`finac-crm/timesheet/open/jobs/charged/hours`, {
    params: {
      ...finalParams,
    },

    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}


export async function getTimeSheetStatustApi(
  token: string
): Promise<AxiosResponse> {
 
  return await getData(`master-module/timesheet/get/locking/status`, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
